import styled from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${({ isDark }) => (isDark ? "#000" : "#fff")};
`;

export const Logo = styled.img`
  width: 23px;
  height: 23px;
  margin-right: 7px;
  border-radius: 50%;
`;

export const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CompanyName = styled.span`
  font-weight: 600;
  font-size: var(--fs-sm);
`;

export const AdText = styled.span`
  font-weight: normal;
  font-size: 10px;
`;
